import * as React from "react"
import Header from "../components/header/Header"
import FirstQuestion from '../components/screens/firstQuestionModule/FirstQuestion'
import SecondQuestion from '../components/screens/secondQuestionModule/SecondQuestion'
import Hero from "../components/screens/hero/Hero"
import PostalCode from "../components/screens/postalCode/PostalCode"
import ThirdQuestion from "../components/screens/thirdQuestionBlok/ThirdQuestion"
import BlueModule from "../components/screens/informationModules/BlueModule"
import PinkModule from "../components/screens/informationModules/PinkModule"
import PartnerModule from "../components/screens/informationModules/PartnerModule"

const IndexPage = () => (
<>
<Header/>
<Hero/>
<PostalCode/>
<FirstQuestion/>
<SecondQuestion/>
<ThirdQuestion/>
<BlueModule/>
<PinkModule/>
<PartnerModule/>
</>
)

export default IndexPage
